import styles from "@/components/context-menu.module.css";
import MenuShell from "@/components/menu-shell";
import globals from "@/globals";
import * as signals from "@/signals";
import { handleKeyboardClick } from "@/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import React, { JSX, useState } from "react";

function ContextMenu(): JSX.Element {
	const [isClosing, setIsClosing] = useState(false);

	const closeMenu = (): void => {
		setIsClosing(true);
		window.setTimeout(() => {
			signals.contextMenuInfo.value = null;
			setIsClosing(false);
		}, globals.ANIMATION_WAIT_TIME);
	};

	const contextMenuInfo = signals.contextMenuInfo.value;
	const itemElements = contextMenuInfo?.items.map((item) => {
		const handleClick = (event?: React.MouseEvent): void => {
			void globals.contextMenuCallbacks[item.text]?.(event);
			closeMenu();
		};

		return (
			<div
				key={item.text}
				className={clsx(
					styles["menu-item"],
					item.isDangerous && styles["dangerous"],
				)}
				role="button"
				tabIndex={0}
				onClick={handleClick}
				onKeyDown={handleKeyboardClick(handleClick)}
			>
				<FontAwesomeIcon
					icon={item.icon}
					fixedWidth
				/>
				<span>{item.text}</span>
			</div>
		);
	});

	return (
		<MenuShell
			className={styles["popup-menu"]}
			isClosing={isClosing}
			onClose={closeMenu}
			isOpen={!!contextMenuInfo}
			x={contextMenuInfo?.x ?? 0}
			y={contextMenuInfo?.y ?? 0}
		>
			{itemElements}
		</MenuShell>
	);
}

export default ContextMenu;
